const UnitEnum = {
    MAN_DAY: 'Čovjek/dan',
    HOUR: 'Sat(i)',
    MONTH: 'Mjesec',
    PCS: 'Kom.'
  };

export default UnitEnum;